import React from 'react'
import '../../assets/libs/@mdi/font/css/materialdesignicons.min.css';
import '../../assets/css/tailwind.css';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { courses, product_category} from '../../axios/api/product_category';
import { useSelector } from 'react-redux';




export default function Navbar(props) {
    const cookie = new Cookies();
    let { navClass, navJustify } = props;
    let [isMenu, setisMenu] = useState(false);
    let [manu , setManu] = useState('');
    let location = useLocation();
    const {navbarReducer} = useSelector(response => response);
    let [isAccount , setIsAccount] = useState(false);
    let [userdata, setUserdata] = useState(null);
   const [logo, setLogo] = useState();
   const [category, setCategory] = useState(null);
   const [products, setProducts] = useState();
   const [ getRes, setGetRes] = useState();
   const {cat_id} = useParams();
   const [pageNo, setPageNo] = useState(1);

    //const site_logo = useSelector((state) => state.websiteReducer.data.data.site_logo);

    const isLogin = useSelector((state)=> state.loginReducer.isLogin);

    const [navData,setNavData] = useState(null);


    useEffect(()=>{

        let current = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)

        setManu(current)

        function windowScroll() {
            const navbar = document.getElementById("topnav");
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                if (navbar !== null) {
                    navbar?.classList.add("nav-sticky");
                }
            } else {
                if (navbar !== null) {
                    navbar?.classList.remove("nav-sticky");
                }
            }
        }
        window.addEventListener("scroll", windowScroll);
        window.scrollTo(0, 0)
        return () => {
            window.removeEventListener('scroll', windowScroll);
        };

    },[location.pathname.substring(location.pathname.lastIndexOf('/') + 1)]);


    const user = JSON.parse(localStorage.getItem('icp_authData'));


    useEffect(()=>{
        if(user)
        {

            setUserdata(user);
        }
        if(cookie.get('icp_favicon'))
            {
                const faviData = cookie.get('icp_favicon');
                setLogo(faviData.site_logo);
            }
        getNavData();
        

    },[]);

    useEffect(()=>{
        getCategory();
        fetchCourses();
    },[]);

    const getCategory = async ()=>{
            const result = await product_category();
            //console.log(result);
    
                if(result.status === 200)
                {
                    if(result.data.status === 1)
                    {
    
                        setCategory(result.data.data);
                        //console.log(result.data.data);
    
                    }
                }
                else
                {
                    if(result.response.data.status === 0)
                    {
                        let msg = result.response.data.message;
    
                        console.log(msg);
    
    
                    }
                }
        }

    const fetchCourses = async ()=>{
            const courseData = {
                category_id: cat_id,
                page:pageNo
            }
            const newData = await courses(courseData);
            //console.log(newData);
            if(newData.status === 200)
                {
                    if(newData.data.status === 1)
                    {
    
                        setGetRes(newData.data.data.data);
                        
                        const newProducts = newData.data.data.data;
                        
                        if(newProducts.length===0)
                        {
                            setProducts(null);
                        }
                        else{
                            setProducts(newProducts);
                        }
    
                        //console.log(newData.data.data.data);
    
                    }
                }
                else
                {
                    if(newData.response.data.status === 0)
                    {
                        //let msg = newData.response.data.message;
    
                           
    
                    }
                }
        }


    const getNavData = ()=>{

        /*if(navbarReducer.status === 1)
            {


            }*/
            if(navbarReducer.data.status ===1)
            {
                setNavData(navbarReducer.data.data);
            }
    }

    const toggleMenu = () => {
        setisMenu(!isMenu);
        if (document.getElementById("navigation")) {
            const anchorArray = Array.from(document.getElementById("navigation").getElementsByTagName("a"));
            anchorArray.forEach(element => {
                element.addEventListener('click', (elem) => {
                    const target = elem.target.getAttribute("href")
                    if (target !== "") {
                        if (elem.target.nextElementSibling) {
                            var submenu = elem.target.nextElementSibling.nextElementSibling;
                            submenu.classList.toggle('open');
                        }
                    }
                })
            });
        }
    };

    //console.log(fullWebData);

    return (
        <nav id="topnav" className={`defaultscroll ${navClass === "nav-light" ? '' : navClass === "nav-sticky" ?
        'bg-white dark:bg-slate-900' : ''}`}>
        <div className="container relative">
            {
                navClass === "nav-light" ?
                    <Link className="logo" to="/index">
                        <span className="inline-block dark:hidden">
                            <img src='../images/Tutormate.png' className="l-dark width20" height="14" alt="logo" />
                            <img src='../images/Tutormate.png' className="l-light width20" height="14" alt="logo" />
                        </span>
                        <img src='../images/Tutormate.png' height="24" className="hidden dark:inline-block" alt="logo" />
                    </Link>
                    :
                    <Link className="logo" to="/index">
                        <img src='../images/Tutormate.png' className="inline-block dark:hidden width20" alt="logo" />
                        <img src='../images/Tutormate.png' className="hidden dark:inline-block width20" alt="logo" />
                    </Link>
            }

            <div className="menu-extras">
                <div className="menu-item">
                    <Link to="#" className={`navbar-toggle ${isMenu ? 'open' : ''}`} id="isToggle" onClick={() => toggleMenu()}>
                        <div className="lines">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </Link>
                </div>
            </div>

    
            <div id="navigation" className="pr-3" style={{ display: isMenu ? 'block' : 'none' }}>
                <ul className={`navigation-menu justify-end ${navClass} ${navJustify}`} >

                    <li className={`${["ui-components", "documentation","changelog"].includes(manu)? "active" : ""} has-submenu parent-menu-item`}>
                        <Link to="">Classes</Link><span className="menu-arrow"></span>
                        <ul className="submenu">
                            {
                                
                                products ?
                                [...products ]
                                .sort((a, b) => {
                            // Extract class numbers from product names
                            const getClassNumber = (name) => {
                                const match = name.match(/CLASS\s*(\d+)/i) || name.match(/\b(\d+)\b/);
                                return match ? parseInt(match[1]) : 0;
                            };
                            
                            const getBoardPriority = (name) => {
                                // MH BOARD comes after regular classes
                                if (name.toLowerCase().includes('mh board')) return 2;
                                if (name.toLowerCase().includes('class')) return 1;
                                return 3;
                            };
                            
                            const aBoard = getBoardPriority(a.product_name);
                            const bBoard = getBoardPriority(b.product_name);
                            
                            // First sort by board type
                            if (aBoard !== bBoard) {
                                return aBoard - bBoard;
                            }
                            
                            // Then sort by class number (ascending)
                            const aClass = getClassNumber(a.product_name);
                            const bClass = getClassNumber(b.product_name);
                            return aClass - bClass;
                        }).map((item, index)=>(
                                    <>
                                        <li className={manu === "ui-components" || "" ? "active" : ""} key={index}><Link to={"/syllabus/"+item.slug} className="sub-menu-item">{item.product_name}</Link></li>
                                    </>
                                )): ''
                            }
                            
                            
                        </ul>
                    </li>

                    <li className={`${["ui-components", "documentation","changelog"].includes(manu)? "active" : ""} has-submenu parent-menu-item`}>
                        <Link to="">Exam</Link><span className="menu-arrow"></span>
                        <ul className="submenu">
                            <li className={manu === "ui-components" || "" ? "active" : ""}><Link to="/exam" className="sub-menu-item">JEE Main</Link></li>
                            <li className={manu === "documentation" || "" ? "active" : ""}><Link to="/jee_advance" className="sub-menu-item">JEE Advanced</Link></li>
                            <li className={manu === "changelog" || "" ? "active" : ""}><Link to="/mh_cet" className="sub-menu-item">MH CET</Link></li>
                            <li className={manu === "changelog" || "" ? "active" : ""}><Link to="/neet" className="sub-menu-item">Neet</Link></li>
                        </ul>
                    </li>


                    <li className={(manu == 'category')?"active":""}>
                        <Link to="/category">Course</Link>

                    </li>

                    <li className={(manu == 'blog')?"active":""}>
                    <Link to="/apps">App</Link></li>


                    {
                    isLogin
                    ? <li className="dropdown inline-block relative ms-1 header_profile ms-4">
                        <button onClick={()=>setIsAccount(!isAccount)} data-dropdown-toggle="dropdown" className="dropdown-toggle size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full bg-indigo-600 hover:bg-indigo-700 border border-indigo-600 hover:border-indigo-700 text-white" type="button">
                            <Link to="/profile"><i className="mdi mdi-account"></i> </Link>
                        </button>
                    </li> :
                    <li className=" inline-block text-white relative ms-1 header_profile header_login_btn mt-1">


                        <Link to="/login" ><span className="text-white">Login</span></Link>
                    </li>}
                    



                </ul>

            </div>
        </div >
    </nav >
    )
}
